import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React from 'react';
import CommonHeader from './CommonHeader.js';
import HeaderName from './HeaderName.js';
import { HeaderNpayButton } from './HeaderNpayButton.js';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.js';

var _excluded = ["serviceType", "rightComponent", "brandLogo", "href", "isMobile", "isPayApp"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 5탭 헤더
 *
 * ### `GlobalConfig` 설정
 * HeaderBrandMain에서 바라보는 도메인을 변경하고자 한다면 `GlobalConfig`의 `setPayDomain`, `setStockDomain`, `setRealEstateDomain`로 전역에 지정할 수 있습니다.
 *
 * [`GlobalConfig` 바로가기](https://oss.fin.navercorp.com/pages/finance-fe/deFign/v7/?path=/docs/getting-started--docs#globalconfig)
 */
function HeaderBrandMain(_ref) {
  var serviceType = _ref.serviceType,
    rightComponent = _ref.rightComponent,
    _ref$brandLogo = _ref.brandLogo,
    brandLogo = _ref$brandLogo === void 0 ? [] : _ref$brandLogo,
    href = _ref.href,
    isMobile = _ref.isMobile,
    isPayApp = _ref.isPayApp,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useHeaderBrandLogo = useHeaderBrandLogo(brandLogo),
    nLogo = _useHeaderBrandLogo.nLogo,
    payLogo = _useHeaderBrandLogo.payLogo;
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "left",
    rightComponent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "blind"
    }, "\uBA54\uB274\uBAA8\uC74C"), rightComponent)
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(HeaderNpayButton, {
    n: nLogo,
    pay: payLogo,
    isMobile: isMobile,
    isPayApp: isPayApp
  }), /*#__PURE__*/React.createElement(HeaderName, _objectSpread({
    serviceType: serviceType,
    size: "large",
    href: href
  }, props))));
}

export { HeaderBrandMain as default };
